import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import HeaderService from 'components/molecules/HeaderService';
import { getUserData } from 'store/profile';
import { getHasAuthenticationLoaded } from '../../store/login';

const mapStateToProps = (state) => ({
	userData: getUserData(state),
	hasAuthenticationLoaded: getHasAuthenticationLoaded(state),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderService as any);
